export const telegram = "https://t.me/Bart2Portal"
export const twitter = "https://twitter.com/bartcoin2"
export const poo = "https://dextools.io/app/en/bnb/pair-explorer/0x5525e958dc774399dd77a2593839b47e9cc71cac"
export const pankcake = "https://pancakeswap.finance/swap?outputCurrency=0x28a9Af9e1B1641c4532AD91D90A003b4A3A7DC32"